import { Select2Helper } from "../../Helpers/Select2Helper";
import { StringHelper } from "../../Helpers/StringHelper";

export class CreateDepartmentXrefManager {

    constructor(private containerElement: JQuery) { }

    public initialize() {
        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;

        self.containerElement.find('select.select2').each((index, element) => {
            var selectElement = $(element);
            Select2Helper.BindSelect2Input(selectElement);
        });
    }

    private bindEvents() {
        var self = this;

        var form =  this.containerElement.find('form');
        var submitButton = form.find(':submit');

        submitButton.off('click').on('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            submitButton.prop('disabled', true);
            form.trigger('submit');
        }) 
    }
}